export default __webpack_public_path__ + "static/media/aeroland-button-google-play.6969b630.webp";